/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImpactDirectionDto } from './ImpactDirectionDto';
import {
	ImpactDirectionDtoFromJSON,
	ImpactDirectionDtoFromJSONTyped,
	ImpactDirectionDtoToJSON,
	ImpactDirectionDtoToJSONTyped,
} from './ImpactDirectionDto';

/**
 *
 * @export
 * @interface DamageDto
 */
export interface DamageDto {
	/**
	 *
	 * @type {string}
	 * @memberof DamageDto
	 */
	referenceNumber?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof DamageDto
	 */
	description?: string | null;
	/**
	 *
	 * @type {Array<ImpactDirectionDto>}
	 * @memberof DamageDto
	 */
	impactDirections?: Array<ImpactDirectionDto> | null;
}

/**
 * Check if a given object implements the DamageDto interface.
 */
export function instanceOfDamageDto(value: object): value is DamageDto {
	return true;
}

export function DamageDtoFromJSON(json: any): DamageDto {
	return DamageDtoFromJSONTyped(json, false);
}

export function DamageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DamageDto {
	if (json == null) {
		return json;
	}
	return {
		referenceNumber: json['referenceNumber'] == null ? undefined : json['referenceNumber'],
		description: json['description'] == null ? undefined : json['description'],
		impactDirections:
			json['impactDirections'] == null
				? undefined
				: (json['impactDirections'] as Array<any>).map(ImpactDirectionDtoFromJSON),
	};
}

export function DamageDtoToJSON(json: any): DamageDto {
	return DamageDtoToJSONTyped(json, false);
}

export function DamageDtoToJSONTyped(
	value?: DamageDto | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		referenceNumber: value['referenceNumber'],
		description: value['description'],
		impactDirections:
			value['impactDirections'] == null
				? undefined
				: (value['impactDirections'] as Array<any>).map(ImpactDirectionDtoToJSON),
	};
}
